import { Inject, Injectable } from '@angular/core'
import { IScope } from 'angular'
import { SeMenuComponent } from './menu.component'

@Injectable({providedIn: 'root'})
export class SeMenuService {

  private menus: { [key: string]: SeMenuComponent } = {}
  private openMenu: SeMenuComponent

  constructor(
    @Inject('$rootScope') private $rootScope: IScope,
  ) {
    document.addEventListener('click', e => this.trigger(e, 'onClick'))
    document.addEventListener('touchend', e => this.trigger(e, 'onTouchEnd'))
    document.addEventListener('touchmove', e => this.trigger(e, 'onTouchMove'))
  }

  public register(menu: SeMenuComponent): void {
    this.menus[menu.referenceId] = menu
  }

  public unregister(menu: SeMenuComponent): void {
    delete this.menus[menu.referenceId]
  }

  private trigger(e: MouseEvent | TouchEvent, method: string): void {
    const prevMenu = this.openMenu
    const el = e.target as HTMLElement
    const target = el.closest('se-menu,se-menu-reference')
    const id = target && target.getAttribute('se-data-reference-id') || ''
    const menu = this.openMenu = this.menus[id]

    this.$rootScope.$apply(() => {
      if (e.type === 'click' && prevMenu && menu !== prevMenu) prevMenu.onClickOff()
      if (menu) menu[method]()
    })
  }
}
